"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultExistingLoginState = void 0;
exports.defaultExistingLoginState = {
    isActive: false,
    t: {
        heading: 'Do you want to login',
        caption: 'You already have an account with us? How about logging in?',
        login: 'Login',
        cancel: 'Cancel',
    },
    email: '',
    loginProvider: '',
};
